import React from 'react';
import { NavLink } from 'react-router-dom';
const Uganda1_primary_subjects = () => {
  return (
    <div className='fixed top-16 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-cyan-400 items-center z-50 justify-evenly'>
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_primary/uganda1_primary_eng" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >English</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_primary/uganda1_primary_math" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Mathematics</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_primary/uganda1_primary_scie" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Science</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_primary/uganda1_primary_soc" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Social Studies</NavLink>        
        
    </div>
  );
}

export default Uganda1_primary_subjects;
